// extracted by mini-css-extract-plugin
module.exports = {"chartCover":"StatsTwo_chartCover__2mU7u","chart":"StatsTwo_chart__2Ecb8","info":"StatsTwo_info__zDrqh","overview":"StatsTwo_overview__vg-x_"};